import { GeneralLedgerAccountsService } from '@/modules/global-settings/general-ledger/services/general-ledger-accounts.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new instance of the general ledger account settings service
const generalLedgerAccountsService = new GeneralLedgerAccountsService();

// General ledger account settings module state
export const state = {
  generalLedgerAccounts: [],
  generalLedgerAccount: {}
};

// General ledger account settings module mutations
export const mutations = {
  ...make.mutations(state),

  SET_GENERAL_LEDGER_ACCOUNT: (state, payload) => {
    state.generalLedgerAccounts = payload;
  },

  ADD_GENERAL_LEDGER_ACCOUNT: (state, payload) => {
    state.generalLedgerAccounts.push(payload);
  },

  UPDATE_GENERAL_LEDGER_ACCOUNT: (state, { id, payload }) => {
    const index = state.generalLedgerAccounts.findIndex((el) => el.id == id);
    state.generalLedgerAccounts.splice(index, 1, payload);
  },

  REMOVE_GENERAL_LEDGER_ACCOUNT(state, id) {
    const index = state.generalLedgerAccounts.findIndex((el) => el.id == id);
    state.generalLedgerAccounts.splice(index, 1);
  },
};

// General ledger account settings module actions
export const actions = {
  ...make.actions(state),

  /**
   * Fetch all general ledger account settings
   * @param {*} Object - Vuex context 
   * @returns Array - General ledger account settings
   */
  fetchGeneralLedgerAccounts: async ({ commit }) => {
    try {
      const { data } = await generalLedgerAccountsService.findAll();
      commit('SET_GENERAL_LEDGER_ACCOUNT', data);
      return data;
    } catch (error) {
      Logger.error('fetching general ledger account settings');
      throw error;
    }
  },

  /**
   * Create a new general ledger account setting
   * @param {*} Object - Vuex context
   * @param {*} Object - General ledger account setting data
   */
  createGeneralLedgerAccount: async ({ commit }, payload) => {
    try {
      const { data } = await generalLedgerAccountsService.create(payload);
      commit('ADD_GENERAL_LEDGER_ACCOUNT', data);
      return data;
    } catch (error) {
      Logger.error('creating general ledger account setting');
      throw error;
    }
  },

  /**
   * Update a general ledger account setting with the given id and data
   * @param {*} Object - Vuex context
   * @param {*} Object - General ledger account setting ID & General ledger account setting data
   */
  updateGeneralLedgerAccount: async ({ commit }, { id, payload }) => {
    try {
      const { data } = await generalLedgerAccountsService.update(id, payload);
      commit('UPDATE_GENERAL_LEDGER_ACCOUNT', { id, payload: data });
      return data;
    } catch (error) {
      Logger.error('updating general ledger account setting');
      throw error;
    }
  },

  /**
   * Delete a general ledger account setting with the given id
   * @param {*} Object - Vuex context
   * @param {*} Object - General ledger account setting ID 
   */
  deleteGeneralLedgerAccount: async ({ commit }, id) => {
    try {
      // Call the service to delete the record
      await generalLedgerAccountsService.delete(id);
  
      // Commit the mutation to remove the record from the state
      commit('REMOVE_GENERAL_LEDGER_ACCOUNT', id);
  
      return true; // Return success response
    } catch (error) {
      Logger.error('Error deleting general ledger account setting', error);
      throw error;
    }
  },
};

// General ledger account settings module getters
export const getters = make.getters(state);
